import { render, staticRenderFns } from "./NewsDetailsEight.vue?vue&type=template&id=c0e8d63e"
import script from "./NewsDetailsEight.vue?vue&type=script&lang=js"
export * from "./NewsDetailsEight.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsEight.vue?vue&type=style&index=0&id=c0e8d63e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports